import React, { useState } from 'react';
import styles from './vacancyConfigurations.module.scss';
import { Col, Container, Row, Form } from 'react-bootstrap';
import { CustomButton } from '../../../../shared/customButton';
import { CustomTextField } from '../../../../shared/customTextField';
import { CustomTextArea } from '../../../../shared/customTextArea';
import { CustomDropdown } from '../../../../shared/customDropdown';
import { Formik } from 'formik';
import * as yup from 'yup';
var currencyCodes = require('currency-codes');

const AddPipelineVacancyConfigurations = (props) => {

    const
        dropValue = [
            {
                label: 'Full-Time',
                value: 10,
            },
            {
                label: 'Part-Time',
                value: 20,
            },
            {
                label: 'Contract/ Temp',
                value: 30,
            },
            {
                label: 'Casual/ Vacation',
                value: 40,
            },
            {
                label: 'Internship',
                value: 50,
            },
        ]
    const
        dropValueSalary = [
            {
                label: 'Hourly',
                value: 10,
            },
            {
                label: 'Daily',
                value: 20,
            },
            {
                label: 'Weekly',
                value: 30,
            },
            {
                label: 'Fortnight',
                value: 40,
            },
            {
                label: 'Monthly',
                value: 50,
            },
        ]
    const
        dropValueMobility = [
            {
                label: 'Remote',
                value: 10,
            },
            {
                label: 'On-Site',
                value: 20,
            },
            {
                label: 'Hybrid',
                value: 30,
            },
        ]    

    let currencyCodeDropdownArray = []
    let currencyCodeArray = currencyCodes.codes()

    for (let index = 0; index < currencyCodeArray.length; index++) {
        let currency_code_object = {
            label: currencyCodeArray[index],
            value: currencyCodeArray[index]
        }

        currencyCodeDropdownArray.push(currency_code_object)
    }


    //yup validations
    const schema = yup.object({
        jobMobility: yup.number().required('Required'),
        jobType: yup.number().required('Required'),
        paidCurrency: yup.string().required('Required'),
        salaryPaidBy: yup.number().required('Required'),
        location: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').max(60, 'Character length should be less than 60'),
        position: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').max(60, 'Character length should be less than 60').required('Required'),
        vacancyDesc: yup.string().trim().matches(/^[^<>=*$^]*$/, 'Remove restricted characters. such as: < > = $ * ^').max(800, 'Character length should be less than 800').required('Required'),
    });

    //on submit function
    const onSubmit = async (values) => {
        props.setPipelineDetails(values)
        props.nextPage(3)
    }


    return (
        <div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <Formik
                            validationSchema={schema}
                            onSubmit={(values) => onSubmit(values)}
                            initialValues={{ vacancyDesc: props.pipelineValues.description, position: props.pipelineValues.hiring_position_label, jobType: props.pipelineValues.jobType, jobMobility: props.pipelineValues.jobMobility, paidCurrency: props.pipelineValues.paidCurrency, salaryPaidBy: props.pipelineValues.salaryPaidBy, location: props.pipelineValues.location }}>
                            {({
                                values,
                                errors,
                                setFieldValue,
                                handleChange,
                                handleSubmit,
                                submitCount
                            }) => (
                                <Form noValidate onSubmit={handleSubmit}>
                                    <Row>

                                        <Col className={styles.pipelineConfigurationsCol}>
                                            <CustomTextField
                                                label="Position"
                                                classLabel="defaultLabel"
                                                controlId="position"
                                                placeholder="ex:- Software Engineer"
                                                type="text"
                                                value={values.position}
                                                name="position"
                                                classType="defaultTextBox"
                                                handleOnChange={handleChange}
                                                maxlength={60}
                                                errorMessage={errors.position}
                                                isInvalid={submitCount > 0 && !!errors.position}
                                            />

                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12} className={styles.pipelineConfigurationsCol}>

                                            <CustomTextArea
                                                label="Job Description"
                                                name="vacancyDesc"
                                                values={values.vacancyDesc}
                                                errorMessage={errors.vacancyDesc}
                                                handleChange={handleChange}
                                                isInvalid={submitCount > 0 && !!errors.vacancyDesc}
                                                remainingCount={(values.vacancyDesc).length}
                                                maxLength={800}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12} className={styles.pipelineConfigurationsCol}>
                                            <CustomDropdown
                                                label="Job Type"
                                                controlId="jobType"
                                                name="jobType"
                                                value={values.jobType}
                                                handleOnChange={(e) => { setFieldValue('jobType', parseInt(e.target.value)); }}
                                                dropdownValues={dropValue}
                                                errorMessage={errors.jobType}
                                                isInvalid={submitCount > 0 && !!errors.jobType}
                                                hiddenOption="Select Job Type"
                                            />
                                        </Col>

                                    </Row>
                                    <Row>
                                        <Col sm={12} className={styles.pipelineConfigurationsCol}>
                                            <CustomDropdown
                                                label="Work Type"
                                                controlId="jobMobility"
                                                name="jobMobility"
                                                value={values.jobMobility}
                                                handleOnChange={(e) => {
                                                    setFieldValue('jobMobility', parseInt(e.target.value));
                                                    // changeType(e.target.value)
                                                }}
                                                dropdownValues={dropValueMobility}
                                                errorMessage={errors.jobMobility}
                                                isInvalid={submitCount > 0 && !!errors.jobMobility}
                                                hiddenOption="Select Work Type"
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12} className={styles.pipelineConfigurationsCol}>
                                            <CustomTextField
                                                label="Location"
                                                classLabel="defaultLabel"
                                                controlId="location"
                                                placeholder="ex:- Colombo, Sri Lanka"
                                                type="text"
                                                value={values.location}
                                                name="location"
                                                classType="defaultTextBox"
                                                handleOnChange={handleChange}
                                                maxlength={60}
                                                errorMessage={errors.location}
                                                isInvalid={submitCount > 0 && !!errors.location}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={6} className={styles.pipelineConfigurationsCol}>
                                            <CustomDropdown
                                                label="Paid Currency"
                                                controlId="paidCurrency"
                                                name="paidCurrency"
                                                value={values.paidCurrency}
                                                handleOnChange={(e) => {
                                                    setFieldValue('paidCurrency', e.target.value);
                                                    // changeType(e.target.value)
                                                }}
                                                dropdownValues={currencyCodeDropdownArray}
                                                errorMessage={errors.paidCurrency}
                                                isInvalid={submitCount > 0 && !!errors.paidCurrency}
                                                hiddenOption="Select Currency"
                                            />
                                        </Col>
                                        <Col sm={6}>
                                            <CustomDropdown
                                                label="Salary Paid By"
                                                controlId="salaryPaidBy"
                                                name="salaryPaidBy"
                                                value={values.salaryPaidBy}
                                                handleOnChange={(e) => {
                                                    setFieldValue('salaryPaidBy', parseInt(e.target.value));
                                                    // changeType(e.target.value)
                                                }}
                                                dropdownValues={dropValueSalary}
                                                errorMessage={errors.salaryPaidBy}
                                                isInvalid={submitCount > 0 && !!errors.salaryPaidBy}
                                                hiddenOption="Select Salary Paid By"
                                            />
                                        </Col>
                                    </Row>
                                    <hr className={styles.dividerLine}/>
                                    <Row className="mt-3 mb-3 d-flex flex-row-reverse">
                                        <div className={styles.navigateBtnCol}>
                                            <CustomButton
                                                id="pipeline_vacancy_config_confirm"
                                                buttonType="submit"
                                                label="Next"
                                                type="primaryBtn"
                                            />
                                        </div>
                                        <div className={styles.navigateBtnCol}>
                                            <CustomButton
                                                id="pipeline_vacancy_config_cancel"
                                                buttonType="button"
                                                label="Back"
                                                type="defaultBtn"
                                                handleClick={() => props.previousPage(1)}
                                            />
                                        </div>

                                    </Row>
                                </Form>
                            )}
                        </Formik>

                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export default AddPipelineVacancyConfigurations;
